import { PARAMS, REGIONS } from "../constants/constants";
import useParam from "./useParam";

export function useGetRegion(): string {
  const regionParam = useParam().get(PARAMS.region) ?? "";
  return REGIONS.includes(regionParam) ? regionParam : "US";
}
